// Boot-time guard for window messages from opaque-origin frames.
//
// A sandboxed frame without allow-same-origin posts with the origin string
// "null". The only such frames in this app are dashboard artifacts, whose
// content is agent-authored. Other parts of the app listen for window
// messages and act on `event.data.message` without checking the sender:
// the card-system listeners in Insight.vue and ShareLayout.vue, and the
// remotely hosted CardRouting.js those two inject, which reloads the page on
// { message: 'refresh_page' } and never removes its listener.
//
// Listeners on window run in registration order, so this guard is installed
// from main.js before the app is created. It stops every "null"-origin
// message there and hands it to the artifact panel, which applies
// acceptArtifactMessage (frame identity and message shape).
//
// No imports: specs load this file into a bare page.

const subscribers = [];
let installedOn = null;

function onWindowMessage(event) {
  if (!event || event.origin !== 'null') return;
  event.stopImmediatePropagation();
  subscribers.slice().forEach((subscriber) => {
    try {
      subscriber(event);
    } catch (error) {
      // A subscriber must not take the guard down with it.
    }
  });
}

export function installArtifactMessageGuard(target) {
  const host = target || (typeof window !== 'undefined' ? window : null);
  if (!host || installedOn === host) return;
  installedOn = host;
  host.addEventListener('message', onWindowMessage, true);
}

// Returns the function that unsubscribes.
export function onArtifactMessage(subscriber) {
  subscribers.push(subscriber);
  return function unsubscribe() {
    const at = subscribers.indexOf(subscriber);
    if (at !== -1) subscribers.splice(at, 1);
  };
}
